import styled from "styled-components";
import { device } from "../../styles/devices";

export const ContactFormContent = styled.div`
        h3 {
            font-size: 1.3rem;
            font-weight: var(--font-medium);
            line-height: 2rem;
            text-align: center;
            margin-bottom: 1rem;
            color: var(--color-black);

            @media ${device.mobile}{
                text-align: initial;
                margin-bottom: 2rem;
            }
        }
`;

export const ContactFormForm = styled.form`

    & > div{
        position: relative;
        height: 4rem;
        margin-bottom: 2rem;

        &.textarea {
            height: 11rem;
        }
    }

    input,textarea {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid var(--color-black);
        background: none;
        color: var(--color-text);
        border-radius: var(--button-radius);
        padding: 1.5rem;
        z-index: 1;
    }



    label{
        position: absolute;
        top: -0.85rem;
        left: 1.25rem;
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: var(--font-medium);
        color: var(--color-title);
        padding: 0.25rem 0.5rem;
        background-color: var(--bg-color);
        z-index: 10;
    }

    textarea{
        resize: none;
    }

    button{
        padding: 1rem 2rem;
        border-radius: var(--button-radius);
        background-color: var(--color-black);
        color: var(--color-white);
        font-weight: var(--font-medium);
        font-size: 1rem;
        display: inline-block;
        transition: .3s ease-in;
        box-shadow: 0 1px 8px rgba(0,0,0,0.15);

        @media ${device.mobile}{
            width: 100%;
            padding: 1rem 1rem;
        }

        &:hover{
            background-color: var(--color-black-hover);
        }

        i {
            font-size: 1.1rem;
            margin-left: .5rem;
            display: inline-block;
            transform: rotate(-45deg);
        }
    }
`;